(() => {
  let announcement;
  let observer;
  let frame;
  let pendingHeight;
  let appliedHeight;
  const applyHeight = (height) => {
    pendingHeight = height;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!announcement?.isConnected || pendingHeight === appliedHeight) return;
      appliedHeight = pendingHeight;
      document.body.style.setProperty('--sega-announcement-height', appliedHeight + 'px');
    });
  };
  const measureFallback = () => {
    if (!announcement?.isConnected || observer || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (announcement?.isConnected) applyHeight(announcement.getBoundingClientRect().height);
    });
  };
  const initialize = () => {
    observer?.disconnect();
    observer = null;
    cancelAnimationFrame(frame);
    frame = 0;
    appliedHeight = undefined;
    announcement = document.querySelector('.announcement-bar-section');
    document.body.classList.toggle('segastore-service-ready', Boolean(announcement));
    if (!announcement) {
      document.body.style.removeProperty('--sega-announcement-height');
      return;
    }
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver((entries) => {
        const entry = entries.find((item) => item.target === announcement);
        if (entry) applyHeight(entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height);
      });
      observer.observe(announcement, {box: 'border-box'});
    } else {
      measureFallback();
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  window.addEventListener('resize', measureFallback, {passive: true});
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
})();
